import React, {useContext, useState} from 'react';

import {useTranslation} from "react-i18next";

import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";

import {ApplicationsTableContext} from "../../../../context/ApplicationsTableContext";
import {OAuthContext} from "../../../../context/OAuthContext";
import {UserContext} from "../../../../context/UserContext";

import {aplicationStatuses} from "../../../Utils/const";
import FetchHelper from "../../../Utils/helper";

import FilterListItem from "./FilterListItem";
import RequestResultSnackbar from "../../RequestResultSnackbar/RequestResultSnackbar";
import {useNavigate} from "react-router-dom";


const FilterList = () => {
    const {oauthData} = useContext(OAuthContext);
    const {
        setTitle,
        setFilteredLists,
        pendingApplicationsList,
        setLoadingApplications,
        activeIndex,
        setActiveIndex,
        inSyncList,
        inInquiringList
    } = useContext(ApplicationsTableContext);
    const { status, endpoints, setUserData, setErrorUser} = useContext(UserContext);
    const helper = new FetchHelper(oauthData.token);
    const { t } = useTranslation('common');
    const navigate = useNavigate();

    const [fetchStatus, setFetchStatus] = useState<{ openSnackbar: boolean, status: "error" | "success" | undefined, message: string }>({
        openSnackbar: false,
        status: undefined,
        message: ""
    });
    const [selectFilterValue, setSelectFilterValue] = useState<string>("");

    const handleFilter = (status: string, idx: number) => {
        updateFilterInfo();
        // clearing the list first before assigning new value
        setFilteredLists([])
        setLoadingApplications(true)
        helper.getApplicationByStatus(status).then(res => {
            setFilteredLists(res)
            setLoadingApplications(false)
        })
            .catch(_ => {
                handleErrorResponseStatus(t("fetch_data_failed"))
                setLoadingApplications(false)
            })
        setActiveIndex(idx)
        setTitle(t(status))
    }

    const handleFilterAssignedToMe = (idx: number) => {
        updateFilterInfo();
        if(endpoints.fetchAssignedToMe){
            setFilteredLists([])
            setLoadingApplications(true)
            setActiveIndex(idx)
            helper.getApplicationAssignedToMe(endpoints.fetchAssignedToMe).then(res => {
                setLoadingApplications(false)
                setFilteredLists(res)
                setTitle(t("assigned_me"))
            }).catch(_ => {
                setLoadingApplications(false)
                handleErrorResponseStatus(t("fetch_data_failed"))
            })
        }

    }

    const handleFilterWaitingForMe = (idx: number) => {
        updateFilterInfo();
        if (endpoints.fetchMyTasks) {
            setFilteredLists([])
            setLoadingApplications(true)
            helper.getApplicationAssignedToMe(endpoints.fetchMyTasks).then(res => {
                setFilteredLists(res)
                setLoadingApplications(false)
            })
                .catch(_ => {
                    setLoadingApplications(false)
                    handleErrorResponseStatus(t("fetch_data_failed"))
                })
            setTitle(t("waiting_me"))
            setActiveIndex(idx)
        }
    }

    const handleFilterWaitingForVP = (idx: number) => {
        updateFilterInfo();
        if (endpoints.fetchQueuedTasks) {
            setFilteredLists([])
            setLoadingApplications(true)
            helper.getApplicationAssignedToMe(endpoints.fetchQueuedTasks).then(res => {
                setFilteredLists(res)
                setLoadingApplications(false)
            }).catch(_ => {
                setLoadingApplications(false)
                handleErrorResponseStatus(t("fetch_data_failed"))
            })
            setTitle(t("waiting_vp"))
            setActiveIndex(idx)
        }
    }

    const handleErrorResponseStatus = (message: string) => {
        setFetchStatus({openSnackbar: true, status: "error", message: message})
    }

    const handleChangeFilter = ( { target : { value }}: { target: { value: string}}) => {
        setSelectFilterValue(value)
        handleFilter(value, -1)
        navigate("/")
    }
    const handleCloseSnackbar = () => setFetchStatus({openSnackbar: false, status: undefined, message: ""})

    const updateFilterInfo = () => {
        helper.getUserData().then(res => setUserData({...res})).catch(error => setErrorUser(prevState => ({
            ...prevState,
            error: true,
            message: error.message
        })))
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column"}}>
            {pendingApplicationsList && <FilterListItem handleFilterLists={() => handleFilter("pending", 1)} currentIdx={activeIndex} idx={1} label={t("all_pending")} total={pendingApplicationsList.length}/>}
            <FilterListItem handleFilterLists={() => handleFilterAssignedToMe(2)} currentIdx={activeIndex} idx={2} label={t("assigned_me")} total={status?.editor?.total}/>
            <FilterListItem label={t("waiting_me")} currentIdx={activeIndex} idx={3} handleFilterLists={() => handleFilterWaitingForMe(3)} icon={<SubdirectoryArrowRightIcon/>} total={status?.editor?.myTasks}/>
            <FilterListItem label={t("waiting_vp")} currentIdx={activeIndex} idx={4} handleFilterLists={() => handleFilterWaitingForVP(4)} icon={<SubdirectoryArrowRightIcon/>} total={status?.editor?.queuedTasks}/>
            <FilterListItem label={t("inquiring")} currentIdx={activeIndex} idx={5} handleFilterLists={() => {setFilteredLists(inInquiringList); setActiveIndex(5); setTitle(t("inquiring"))}} total={inInquiringList.length}/>
            <FilterListItem label={t("in-sync")} currentIdx={activeIndex} idx={6} handleFilterLists={() => {setFilteredLists(inSyncList); setActiveIndex(6); setTitle(t("in-sync"))}} total={inSyncList.length}/>
            {aplicationStatuses && aplicationStatuses.length !== 0 ? <FormControl fullWidth sx={{ mt: 3}} variant="standard">
                <Select id="select-filter" value={selectFilterValue} onChange={handleChangeFilter} displayEmpty>
                    <MenuItem value="" disabled>{t("select_filter")}</MenuItem>
                    {aplicationStatuses.map((stat, idx)=><MenuItem key={idx} value={stat}>{t(`${stat}`)}</MenuItem>)}
                </Select>
            </FormControl>  : null }
            <RequestResultSnackbar anchorOrigin={{vertical: "top", horizontal: "right"}} open={fetchStatus.openSnackbar}
                                   onClose={handleCloseSnackbar} autoHideDuration={3000} status={fetchStatus.status}
                                   message={fetchStatus.message}/>
        </Box>
    );
};

export default FilterList;